/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { jsx, css } from '@emotion/react';
import { SketchPicker, ChromePicker, TwitterPicker, BlockPicker } from 'react-color';
import Popup from '@atlaskit/popup';
import Button from 'components/button';
import { colors } from '@atlaskit/theme';

type Props = {
  onChange: (value: string) => void;
  value: string;
};



const popoverCss = css`
  position: absolute;
  z-index: 2;
`;

const coverCss = css`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

const presetColors = [
  {color: '#FF6900', title: ''},
  {color: '#FCB900', title: ''},
  {color: '#7BDCB5', title: ''},
  // {color: '#00D084', title: ''},
  {color: '#13C181', title: ''},
  {color: '#8ED1FC', title: ''},
  {color: '#0693E3', title: ''},
  {color: '#ABB8C3', title: ''},
  {color: '#EB144C', title: ''},
  {color: '#F78DA7', title: ''},
  {color: '#9900EF', title: ''},
  // {color: '#091E42', title: ''},
  // {color: '#172B4D', title: ''},
  // {color: '#42526E', title: ''},
  // {color: '#5E6C84', title: ''},
  // {color: '#B3BAC5', title: ''},
  // {color: '#DFE1E6', title: ''},
  {color: '#000000', title: ''},
  // {color: '#333333', title: ''},
  {color: '#555555', title: ''},
  {color: '#777777', title: ''},
  {color: '#999999', title: ''},
  {color: '#CCCCCC', title: ''},
  {color: '#E5E5E5', title: ''},




];
export const ColorPicker: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { onChange, value } = props;
  const [color, setColor] = useState(value);

  useEffect(() => {
    setColor(value)
  },[value]);
  const swatchCss = css`  
  display: inline-block;
  position: relative;
  width: 30px;
  height: 30px;
  border: 2px solid transparent;
  box-sizing: border-box;
  border-radius: 6px;
  transition: border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;
  background-color: transparent;
  padding: 0px;
  cursor: pointer;
  outline: none;
  :hover, :focus {
    border-color: ${color}
  }
`;
  //border-color: ${colors.linkOutline()}

  const colorCss = css`
      width: 36px;
      height: 14px;
      //border-radius: 2px;
      background: ${color};
      position: absolute;
      top: 1px;
      left: 1px;
      width: 24px;
      height: 24px;
      border-radius: 3px;
      :focus {
        border-color: ${color};
      }
    `;
  // background: rgba(${this.state.color.r} ${this.state.color.g} ${this.state.color.b} ${this.state.color.a});

  return (
    <div>
      <div css={swatchCss} onClick={() => setIsOpen(!isOpen)} aria-label="Change color" aria-expanded="false" aria-haspopup="true">
        <div css={colorCss} />
      </div>
      {isOpen ? (
        <div css={popoverCss}>
          <div css={coverCss} onClick={() => setIsOpen(false)} />
          <SketchPicker color={color}
                        presetColors={presetColors}
                         disableAlpha
                        onChange={color => setColor(color.hex)}
                        onChangeComplete={color => onChange(color.hex)}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ColorPicker;
